<div *ngIf="isTabletOrSmaller$ | async" class="mobile-navbar" [class.mobile-navbar-open]="isMobileNavOpen$ | async">
  <div class="wrapper">
    <img
      (click)="navigateToRoot()"
      [src]="'assets/logo/purple/spp-logo.svg'"
      alt="logo"
      i18n-alt
      class="mobile-nav-logo" />
    <button
      *ngIf="(navItems$ | async)?.length > 0"
      class="toggle-button"
      (click)="toggleNavbarCollapse()"
      [attr.aria-expanded]="!(isNavbarCollapsed$ | async)"
      aria-controls="mobile-collapse">
      <div id="hamburger-icon" [class.open]="!(isNavbarCollapsed$ | async)">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </button>
  </div>
  <div
    id="mobile-collapse"
    class="mobile-collapse"
    [class.mobile-collapse-open]="isMobileNavOpen$ | async"
    [ngbCollapse]="isNavbarCollapsed$ | async">
    <ul class="mobile-nav-list">
      <li *ngFor="let navItem of navItems$ | async">
        <app-nav-item *ngIf="navItem | isDefaultNavItem" [navItem]="navItem" />
        <app-profile-nav-item *ngIf="navItem | isProfileNavItem" [navItem]="navItem" />
        <app-sign-out-nav-item *ngIf="navItem | isSignOutNavItem" [navItem]="navItem" />
        <app-mobile-drop-down-nav-item *ngIf="navItem | isDropDownNavItem" [navItem]="navItem" />
      </li>
    </ul>
  </div>
</div>
